export const environment = {
  apiBaseUrl: 'https://api.dev.careconne.jp/',
  tokenApiUrl: 'https://api.dev2.token.ck1lab.net/',
  passWebappUrl: 'https://dev2.pass.ck1lab.net/',
};
